import { uploadCustomerPricingData } from "@crescentParts/Services/CustomerPricingService";
import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import getCustomerPricing from "@crescentParts/Store/Data/CustomerPricing/Handler/CustomerPricingHandler";
import uploadCustomerPricing from "@crescentParts/Store/Data/CustomerPricing/Handler/UploadCustomerPricingHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import FileUpload from "@insite/mobius/FileUpload";
import RefreshCw from "@insite/mobius/Icons/RefreshCw";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";
import * as XLSX from "xlsx";

export interface PricingWidgetStyles {
    mainWrapper?: InjectableCss;
}

const styles: PricingWidgetStyles = {
    mainWrapper: {
        css: css`
        `,
    }
};

const enum fields {
    borderColor = "borderColor",
    borderWidth = "borderWidth",
    borderRadius = "borderRadius",
    padding = "padding",
    marginTop = "marginTop",
    marginBottom = "marginBottom",
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        isAuthenticated: state.context.session?.isAuthenticated
    };
};
const mapDispatchToProps = {
};
type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory & {
    fields: {
        borderColor: string;
        borderWidth: string;
        borderRadius: string;
        padding: string;
        marginTop: string;
        marginBottom: string;
    };
};


export const ProductDetailsRightSideContainer: React.FunctionComponent<Props> = ({
    isAuthenticated,
    id,
    fields,
}: Props) => {
    
    if (!isAuthenticated) {
        return null;
    }

    return (
        <StyledWrapper {...styles.mainWrapper}>
            <BorderedContentWrapper
                borderColor={fields.borderColor}
                borderWidth={fields.borderWidth}
                borderRadius={fields.borderRadius}
                padding={fields.padding}
                marginTop={fields.marginTop}
                marginBottom={fields.marginBottom}
            >
                <Zone contentId={id} zoneName="Content1" />
            </BorderedContentWrapper>
        </StyledWrapper>
    );
};

const BorderedContentWrapper = styled.div<
    {
        borderColor: string;
        borderWidth: string;
        borderRadius: string;
        padding: string;
        marginTop: string;
        marginBottom: string;
    } & InjectableCss
>`
    ${({ borderWidth, borderColor }) => (borderWidth ? `border: ${borderWidth}px solid ${borderColor || "#F6F4F6"};` : null)};
    ${({ borderRadius }) => (borderRadius ? `border-radius: ${borderRadius}px;` : null)};
    ${({ padding }) => (padding ? `padding: ${padding}px;` : null)};
    ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop}px;` : null)};
    ${({ marginBottom }) => (marginBottom ? `margin-bottom: ${marginBottom}px;` : null)};
    ${injectCss}
`;

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ProductDetailsRightSideContainer)),
    definition: {
        group: "Basic",
        icon: "diamond",
        displayName: "Product details right side container",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.borderColor,
                editorTemplate: "ColorPickerField",
                displayName: "Border Color",
                defaultValue: "#F6F4F6",
            },
            {
                fieldType: "General",
                name: fields.borderWidth,
                editorTemplate: "TextField",
                displayName: "Border Width",
                defaultValue: "1",
            },
            {
                fieldType: "General",
                name: fields.borderRadius,
                editorTemplate: "TextField",
                displayName: "Border Radius",
                defaultValue: "15",
            },
            {
                fieldType: "General",
                name: fields.padding,
                editorTemplate: "TextField",
                displayName: "Padding",
                defaultValue: "15",
            },
            {
                fieldType: "General",
                name: fields.marginTop,
                editorTemplate: "TextField",
                displayName: "Margin Top",
                defaultValue: "0",
            },
            {
                fieldType: "General",
                name: fields.marginBottom,
                editorTemplate: "TextField",
                displayName: "Margin Bottom",
                defaultValue: "0",
            },
        ],
    },
};

export default widgetModule;
